// Shared Tailwind class strings for the few styles repeated verbatim across the
// app. Centralizing them keeps the purple/violet theme consistent.

// Primary (page) action button — gradient, py-3 px-6.
export const PRIMARY_BTN =
  'bg-gradient-to-r from-purple-500 to-violet-500 hover:from-purple-600 hover:to-violet-600 text-white font-semibold py-3 px-6 rounded-lg transition-all duration-200 transform hover:scale-105 shadow-lg';

// Secondary / cancel button — neutral, px-6 py-3.
export const SECONDARY_BTN =
  'bg-gray-700/50 hover:bg-gray-600/50 text-gray-300 hover:text-white px-6 py-3 rounded-lg font-medium transition-all duration-200 border border-gray-600 hover:border-gray-500';

// Translucent panel / card container.
export const CARD =
  'bg-gray-800/50 backdrop-blur-sm border border-purple-500/20 rounded-xl';

// Form input field.
export const INPUT =
  'w-full px-4 py-3 bg-gray-700/50 border border-gray-600 rounded-lg text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent transition-all duration-200';

// Form field label.
export const LABEL = 'block text-sm font-medium text-gray-300 mb-2';

// --- Form builder controls -------------------------------------------------
// App.css sets a global blue background on every <button>, so each of these
// must declare its own bg-* and padding to stay on the purple/violet theme.

// Small gradient action button with a label (Add option, Save as preset).
export const ACTION_BTN =
  'inline-flex items-center gap-2 bg-gradient-to-r from-purple-500 to-violet-500 hover:from-purple-600 hover:to-violet-600 text-white text-sm font-medium px-3 py-2 rounded-lg transition-all duration-200 shadow disabled:opacity-40 disabled:cursor-not-allowed';

// Icon-only gradient button (the question card's drag handle). Kept compact so
// it fits inside a collapsed question card.
export const ICON_BTN =
  'inline-flex items-center justify-center bg-gradient-to-r from-purple-500 to-violet-500 hover:from-purple-600 hover:to-violet-600 text-white p-1.5 rounded-lg transition-all duration-200 shadow disabled:opacity-40 disabled:cursor-not-allowed';

// Destructive icon button: purple at rest so it sits on the theme, red on hover
// so deleting still announces itself before the click lands.
export const DANGER_ICON_BTN =
  'inline-flex items-center justify-center bg-purple-500/15 border border-purple-400/30 text-purple-200 hover:bg-red-500 hover:border-red-400 hover:text-white p-2 rounded-lg transition-all duration-200';

// Quiet neutral grip (the drag handle on a dropdown option). Deliberately
// duller than ICON_BTN: a whole column of these appears at once when the option
// rail opens, and a column of gradients would shout.
export const GRIP_ICON_BTN =
  'inline-flex items-center justify-center bg-gray-700/80 hover:bg-gray-600 text-gray-200 p-1.5 rounded-lg transition-colors';

// Quiet inline icon button that sits beside a line of text (the rename pencil).
// Transparent at rest so it never competes with the label next to it.
export const GHOST_ICON_BTN =
  'inline-flex items-center justify-center bg-transparent hover:bg-purple-500/15 text-gray-400 hover:text-purple-200 p-1.5 rounded-lg transition-colors duration-200';
